import Tone from 'tone';

export function getMilliseconds(time) {
    return new Tone.Time(time).toMilliseconds() - new Tone.Time(Tone.Master.context.currentTime).toMilliseconds();
}
